import { Form } from "antd";
import { StyledFormItem } from "./style";
import { FormItemProps, FormProps } from "./type";

function AntForm(props: FormProps) {
  return <Form {...props} />;
}

function AntFormItem(props: FormItemProps) {
  return <StyledFormItem {...props} />;
}

export const FormProvider = Form.Provider;
export const useForm = Form.useForm;
export const useFormWatch = Form.useWatch;
export { AntForm as Form, AntFormItem as FormItem };
